import React from "react";
import {
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IStackTokens,
  Label,
  PanelType,
  SelectionMode,
  Stack,
  TextField,
  TooltipHost,
} from "office-ui-fabric-react";
import { updateCustomerTempHumidityDetails } from "../../../services/customers/CustomerService";
import { Loading } from "../../../services/Loading";
import CustomDrawer from "../../common/CustomDrawer";
import NoDataTile from "../../common/NoDataTile";
import moment from "moment";
import { childrenGap } from "../../common/Constants";
import {
  mdiArrowDown,
  mdiArrowUp,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiPencilOutline,
} from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import Icon from "@mdi/react";
import { IMorTempRhReadings, ITempRhDetails } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { getMorSensorTempAndRhReadings } from "../../../services/infrastructure-automation/InfrastructureAutmationService";
import { toFixedValue } from "../../../services/UtilService";

export interface ManageTempAndRhDialogProps {
  handleDialogClose: any;
  //   handleLoading: any;
  data: IMorTempRhReadings;
  floorId?: string;
  date: Date | string;
  slaMatrix: any;
}

const ManageTempAndRhDialog: React.FC<ManageTempAndRhDialogProps> = ({
  handleDialogClose,
  data,
  floorId,
  date,
  slaMatrix,
}) => {
  //custom hooks
  const { showToast } = React.useContext(ToastContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    tempRhDetails: [],
    index: undefined,
    isOnEdit: false,
    tempRhObj: {
      id: "",
      date: new Date(),
      temp: undefined,
      rh: undefined,
      sensorId: "",
    },
  } as {
    isLoading: boolean;
    tempRhDetails: ITempRhDetails[];
    index?: number;
    isOnEdit: boolean;
    tempRhObj: ITempRhDetails;
  });

  //hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getTempRhDetails();
    };
    asyncFunc();
  }, []);

  const getTempRhDetails = async () => {
    setState({ ...state, isLoading: true });
    let result = await getMorSensorTempAndRhReadings({
      date: moment(date).format("YYYY-MM-DD"),
      sensorId: data.sensorId,
    });
    if (result?.success) {
      //   let tempRhDetails: ITempRhDetails[] = [];
      //   console.log(result.data);
      //   result.data.data.map((ele: any) => {
      //     tempRhDetails.push({
      //       id: ele._id,
      //       date: ele.date,
      //       rh: ele.rh,
      //       temp: ele.temp,
      //       sensorId: ele.sensorId,
      //       sensorName: result.data.sensors.find(
      //         (item: any) => item._id === ele.sensorId
      //       )?.name,
      //     });
      //   });
      setState({
        ...state,
        tempRhDetails: result.data,
        isLoading: false,
      });
    } else {
      setState({
        ...state,
        isLoading: false,
      });
      showToast(
        result?.message || "Error while getting Temp & Rh details",
        "error"
      );
    }
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal tokens={childrenGap}>
            {state.isOnEdit && state.index === index ? (
              <React.Fragment>
                <TooltipHost
                  content={`Save`}
                  id={`saveTempRh`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span onClick={onUpdateTempRh}>
                    <Icon
                      path={mdiCheckCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="green"
                    />
                  </span>
                </TooltipHost>
                <TooltipHost
                  content={`Cancel`}
                  id={`cancelTempRh`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span
                    onClick={() =>
                      setState({
                        ...state,
                        isOnEdit: false,
                        index: undefined,
                        tempRhObj: {
                          id: "",
                          date: new Date(),
                          temp: undefined,
                          rh: undefined,
                          sensorId: "",
                        },
                      })
                    }
                  >
                    <Icon
                      path={mdiCloseCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="red"
                    />
                  </span>
                </TooltipHost>
              </React.Fragment>
            ) : (
              <TooltipHost
                content={`Edit`}
                id={`editTempRh`}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { display: "inline-block" } }}
              >
                <span
                  onClick={() =>
                    setState({
                      ...state,
                      isOnEdit: true,
                      index,
                      tempRhObj: item,
                    })
                  }
                >
                  <Icon
                    path={mdiPencilOutline}
                    size={0.8}
                    className="pointer"
                    color={THEME.palette.neutralPrimary}
                  />
                </span>
              </TooltipHost>
            )}
          </Stack>
        );
      case "temp":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.tempRhObj.temp)}
                type="number"
                name="temp"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              <React.Fragment>
                <span
                  className={isTempInThreshold(item.temp) ? "text-danger" : ""}
                >
                  {/* {item.temp.toFixed(2)} */}
                  {toFixedValue(item.temp)}
                </span>
                {isTempInThreshold(item.temp) && (
                  <Icon
                    path={
                      item.temp < slaMatrix.temperature.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "rh":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.tempRhObj.rh)}
                type="number"
                name="rh"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              <React.Fragment>
                <span className={isRhInThreshold(item.rh) ? "text-danger" : ""}>
                  {/* {item.rh.toFixed(2)} */}
                  {toFixedValue(item.rh)}
                </span>
                {isRhInThreshold(item.rh) && (
                  <Icon
                    path={
                      item.rh < slaMatrix.humidity.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "date":
        return (
          <span style={{ fontWeight: 600 }}>
            {moment(item.date).format("hh:mm:ss")}
          </span>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      tempRhObj: {
        ...state.tempRhObj,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onUpdateTempRh = async () => {
    console.log("temprhobj", state.tempRhObj);
    if (!state.tempRhObj.temp) {
      showToast("Temperature field is required", "error");
    } else if (!state.tempRhObj.rh) {
      showToast("Humidity field is required", "error");
    } else {
      setState({ ...state, isLoading: true });
      let tempRhObj = { ...state.tempRhObj };
      tempRhObj.temp = Number(tempRhObj.temp);
      tempRhObj.rh = Number(tempRhObj.rh);
      let result = await updateCustomerTempHumidityDetails(tempRhObj);
      if (result?.success) {
        let tempRhDetails = [...state.tempRhDetails];
        if (state.index !== undefined) {
          tempRhDetails[state.index].temp = result.data?.temp || 0;
          tempRhDetails[state.index].rh = result.data?.rh || 0;
        }
        setState({
          ...state,
          tempRhDetails,
          tempRhObj: {
            id: "",
            date: new Date(),
            temp: undefined,
            rh: undefined,
            sensorId: "",
          },
          isOnEdit: false,
          index: undefined,
          isLoading: false,
        });
        showToast("Temp & Rh value updated successfully", "success");
      } else {
        setState({ ...state, isLoading: false });
        showToast(result?.message || "Error while updating temp & rh", "error");
      }
    }
  };

  const isTempInThreshold = (tempValue: number) => {
    if (!slaMatrix || !slaMatrix.temperature) return false;
    if (
      tempValue < slaMatrix.temperature.min ||
      tempValue > slaMatrix.temperature.max
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isRhInThreshold = (rhValue: number) => {
    if (!slaMatrix || !slaMatrix.humidity) return false;
    if (rhValue < slaMatrix.humidity.min || rhValue > slaMatrix.humidity.max) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title="View Temp & Rh Details"
        handelOpen={true}
        onClose={() => handleDialogClose()}
      >
        {state.isLoading && <Loading />}
        <Stack className="pt-16">
          <Stack.Item>
            <Label>
              Sensor Name:{" "}
              <span style={{ color: "#135c8a" }}>{data.sensorName}</span>
            </Label>
          </Stack.Item>
          <Stack.Item className="pt-16">
            {state.tempRhDetails && state.tempRhDetails.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.tempRhDetails}
                  columns={[
                    {
                      key: "date",
                      name: "Time",
                      fieldName: "date",
                      minWidth: 50,
                      maxWidth: 100,
                      isResizable: true,
                    },
                    // {
                    //   key: "sensorName",
                    //   name: "Sensor Name",
                    //   fieldName: "sensorName",
                    //   minWidth: 50,
                    //   maxWidth: 100,
                    //   isResizable: true,
                    // },
                    {
                      key: "temp",
                      name: "Temperature",
                      fieldName: "temp",
                      minWidth: 80,
                      maxWidth: 130,
                      isResizable: true,
                    },
                    {
                      key: "rh",
                      name: "Humidity",
                      fieldName: "rh",
                      minWidth: 80,
                      maxWidth: 130,
                      isResizable: true,
                    },
                    // {
                    //   key: "actions",
                    //   name: "Actions",
                    //   fieldName: "actions",
                    //   minWidth: 80,
                    //   maxWidth: 130,
                    //   isResizable: true,
                    // },
                  ]}
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Databases Found"></NoDataTile>
            )}
          </Stack.Item>
          <br />
          <Stack.Item align="end">
            <DefaultButton
              text="Cancel"
              onClick={() => handleDialogClose()}
              className="borderless-btn"
            />
          </Stack.Item>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageTempAndRhDialog;
